import { USE_MOCK } from "../config.js";
import * as mock from "../mocks/accounts.mock.js";

export function listAccounts() {
  return mock.listAccounts();
}

export function createAccount(payload) {
  return mock.createAccount(payload);
}

export function updateAccount(payload) {
  return mock.updateAccount(payload);
}

export function deleteAccount(id) {
  return mock.deleteAccount(id);
}

export function listAccountsLive() {
  if (USE_MOCK) return listAccounts();
  throw new Error("Live API not configured");
}
